import { useDrag } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { ItemTypes } from "../../../abstract/controller/enum/dnd/ItemTypes";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as uuidUtils from "../../../abstract/controller/utils/uuidUtils";
import useNode from "../../../abstract/hook/useNode";
import { resetGenerator } from "../../../abstract/redux/slice/generatorSlice";
import { setDrag, setIdle } from "../../../abstract/redux/slice/statusSlice";
import { getIdFunction, setIdFunction } from "../../../abstract/redux/slice/structureSlice";
import Icon317ArrowRight2 from "../../../themes/icons/Icon317ArrowRight2";
import FunctionHeader from "./FunctionHeader";
import styles from "./FunctionMain.module.scss";

function FunctionMain({ id }) {
  const _dispatch = useDispatch();
  const _node = useNode(id);

  const _uuid = nodeUtils.getUUID(_node);
  const _m_uuid = uuidUtils.getMainUuid(_uuid);

  const [, drag] = useDrag(() => ({
    type: ItemTypes.FUNCTION,
    item: { element: _node },
    isDragging(monitor) {
      return id === monitor.getItem()?.element?.id;
    },
  }));

  const handleModelChange = (id) => {
    _dispatch(setIdFunction(id));
    _dispatch(resetGenerator())
  };

  const handleOnDragStart = (e) => {
    if (e.target.id.includes(_uuid)) {
      const _element = document.querySelector(`#${_m_uuid}`);
      const _size = _element.getBoundingClientRect();
      _dispatch(setDrag({ id, size: { width: _size.width, height: _size.height } }));
    }
  };

  const handleOnDragEnd = () => {
    _dispatch(setIdle());
  };


  const canDrag = () => {
    // return Boolean(nodeUtils.getName(node));
    return true;
  };

  return (
    <li className={styles["function"]}>
      <FunctionSelection id={id} />
      <div
        id={_m_uuid}
        className={styles['function-content']}
        ref={canDrag() ? drag : null}
        onClick={() => handleModelChange(id)}
        onDragStart={handleOnDragStart}
        onDragEnd={handleOnDragEnd}>
        <FunctionHeader node={_node} uuid={_m_uuid} />
      </div>
    </li>
  );
}

const FunctionSelection = ({ id }) => {
  const _idFunction = useSelector(getIdFunction);

  return (
    <div className={styles["function-selector"]}>
      {id !== _idFunction ? "" : <Icon317ArrowRight2 />}
    </div>
  );
};

export default FunctionMain;
